import dom, { Fragment } from "../../../../dist/jsx-render/dom";
import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import { DynPopup } from "../../../Components/DynPopup";
import { WidgetMeasureTree, MarkupMeasureTreeModel, MeasureTreeTypeEnum, optionsMeasureTreeModel } from "../Widgets/WidgetMeasureTree";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { app } from "../../../Frame/App";
import { ListItem } from "../../../Model/ListItem";
import { AceEditorComponent } from "../../../Components/AceEditorComponent";
import { ListView, ListViewProps } from "../../../Components/ListView/ListView";
import { IListItemInternalComponentProps } from "../../../Components/ListView/ListItem";
import { CheckboxComponentProps, CheckboxCompoment } from "../../../Components/CheckboxComponent";
import { TextComponent } from "../../../Components/TextComponent";


export class OptionsMeasureTreeListItemProps implements IListItemInternalComponentProps {
    model?: any;
    displayProperty?: "templateName";
}
export class OptionsMeasureTreeListItem extends JSXComponent {
    props: OptionsMeasureTreeListItemProps;
    constructor(props: OptionsMeasureTreeListItemProps) { super(props) }

    render() {
        let label = Resources['WidgetClient'].button + " '" + Resources.Common.new + " " + this.props.model[this.props.displayProperty] + "'";
        let changeErledigtCheckBoxPropsElement: CheckboxComponentProps = {
            model: this.props.model,
            field: "hasButtonNew",
            label: label,
            createFormGroup: false,
        };

        var element = <div className="item-element name-container block-list-item">
            <div className="item-element flex-row template-name" style={{ flex: "1 1 20em" }} >
                {this.props.model[this.props.displayProperty]}
            </div>
            <div className="item-element flex-row pl-2" style={{ flex: "0 0 20em" }}>
                {new CheckboxCompoment(changeErledigtCheckBoxPropsElement).render()}
            </div>
        </div>;

        return element;
    }
}

export type PopupMeasureTreeComponentProps = {
    widget: WidgetMeasureTree;
}

export class PopupMeasureTreeComponent extends JSXComponent {
    props: PopupMeasureTreeComponentProps;
    clientId: string;
    markup: MarkupMeasureTreeModel[];
    styles: string;
    json: string;
    templateId: string;
    viewId: number;
    templateOptions: optionsMeasureTreeModel[];

    templateItems: ListItem[] = [];
    templateChildItems: ListItem[] = [];

    templateDropdown: DropDownComponent;
    ansichtDropdown: DropDownComponent;
    optionsListview: ListView;

    constructor(props: PopupMeasureTreeComponentProps) {
        super(props);

        this.clientId = this.props.widget.props.clientId;
        this.markup = this.props.widget.props.markup;
        this.styles = this.props.widget.props.styles;
        this.json = this.props.widget.props.json;
        this.templateId = this.props.widget.props.templateId;

        this.viewId = this.props.widget.props.viewId;
        if (this.viewId == NaN || this.viewId == undefined)
            this.viewId = 0;

        this.templateOptions = this.props.widget.props.templateOptions;
        if (app.isNullOrUndefined(this.templateOptions)) {
            this.templateOptions = [];
        }
    }

    onSave = (): boolean => {
        this.props.widget.props.clientId = this.clientId;
        this.props.widget.props.templateId = this.templateDropdown.getValue() == "undefined" ? "0" : this.templateDropdown.getValue();
        this.props.widget.props.styles = this.styles;
        this.props.widget.props.json = this.json;

        if (this.props.widget.props.templateId != "0" && this.markup.find(f => f.templateId == 0)) {
           this.markup.find(f => f.templateId == 0).templateId = parseInt(this.props.widget.props.templateId);
        }
        this.props.widget.props.markup = this.markup;
        this.props.widget.props.viewId = this.ansichtDropdown.getValue() == undefined ? 0 : parseInt(this.ansichtDropdown.getValue());
        this.props.widget.props.templateOptions = this.templateOptions;
        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;

    getElement = () => {
        this.element =
            <DynPopup size="fullscreen" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
                title={Resources['WidgetClient'].widgetMeasureTree}>
                <div className="d-flex flex-column h-100">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="settings-tab" data-toggle="tab" href="#settings" role="tab" aria-controls="settings" aria-selected="true">{Resources["WidgetClient"].tabSettings}</a>
                        </li>
                        <li class="nav-item nav-design-parent" role="presentation">
                        {this.templateId ?
                            <a class="nav-link" id="design-tab" data-toggle="tab" href="#design" role="tab" aria-controls="design" aria-selected="false">{Resources["WidgetClient"].designHtml} - {this.getTemplateName(this.props.widget.props.templateId)} ({this.props.widget.props.templateId}) </a>
                            : <a class="nav-link" id="design-tab" data-toggle="tab" href="#design" role="tab" aria-controls="design" aria-selected="false">{Resources["WidgetClient"].designHtml} </a>
                        }
                        </li>

                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="styles-tab" data-toggle="tab" href="#styles" role="tab" aria-controls="styles" aria-selected="false">{Resources["WidgetClient"].styles}</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="json-tab" data-toggle="tab" href="#json" role="tab" aria-controls="json" aria-selected="false">{Resources["WidgetClient"].json}</a>
                        </li>
                    </ul>
                <div class="tab-content mt-2 flex-grow-1" id="myTabContent">
                    <div class="tab-pane fade h-100 show active" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                        <TextComponent model={this} field="clientId" name={Resources["WidgetClient"].clientId} />
                        {this.renderTemplateDropdown()}
                        {this.renderAnsichtDropdown()}
                    </div>
                    {this.templateId ?
                        <div class="tab-pane fade h-100 tab-design-parent" id="design" role="tabpanel" aria-labelledby="design-tab">
                            {this.renderMarkupEditor(parseInt(this.templateId), MeasureTreeTypeEnum.parent)}
                        </div>
                        : <div class="tab-pane fade h-100 tab-design-parent" id="design" role="tabpanel" aria-labelledby="design-tab">
                            {this.renderMarkupEditor(0, MeasureTreeTypeEnum.parent)}
                        </div>
                    }

                    <div class="tab-pane fade h-100" id="styles" role="tabpanel" aria-labelledby="styles-tab">
                        {this.renderStylesEditor()}
                    </div>
                    <div class="tab-pane fade h-100" id="json" role="tabpanel" aria-labelledby="json-tab">
                        {this.renderJsonEditor()}
                    </div>
                    </div>
                </div>
            </DynPopup>;
    }

    getTemplateName = (id: string): string => {
        let name = "";
        if (!app.isNullOrUndefined(id) && id != "0") {
            let item = this.templateItems.find(f => f.id == id);
            if (item)
                name = item.name ;
        }
        return name;
    }

    renderTemplateDropdown(): HTMLElement {
        this.templateDropdown = new DropDownComponent({
            id: "popupMeasureTreeTemplateList",
            name: Resources['WidgetClient'].templates,
            displayProperty: "name",
            valueProperty: "id",
            addEmptyItem: true,
            items: this.templateItems,
            onChange: this.onTemplateChange,
            selectedValue: this.props.widget.props.templateId
        });
        return this.templateDropdown.render();
    }

    onTemplateChange = (control: DropDownComponent) => {
        // initialize data
        this.templateChildItems = [];
        this.markup = [];
        this.templateOptions = [];

        var item = control.getSelectedItem();
        if (item && item.id) {
            // create new markupEditor for the given template
            this.element.querySelector("#myTabContent").querySelector("#design").innerHTML = "";
            this.element.querySelector("#myTabContent").querySelector("#design").appendChild(this.renderMarkupEditor(parseInt(item.id), MeasureTreeTypeEnum.parent));

            // create nav & markupEditor for each child
            this.createTemplateChildTabs(item.id);

            // create template optionsListview: Add button 'new'
            this.fillTemplateOptions(parseInt(item.id));
            this.element.querySelector("#settings")?.appendChild(this.renderOptionsListview());

        } else {
            this.element.querySelector("#myTab").querySelector("#design-tab").innerHTML = Resources["WidgetClient"].designHtml;

            // remove all child tab if exist
            this.element.querySelector("#myTab")?.querySelectorAll(".nav-design-child")?.forEach(e => e.remove());
            this.element.querySelector("#myTabContent")?.querySelectorAll(".tab-design-child")?.forEach(e => e.remove());

            // remove optionsListview
            this.element.querySelector("#settings")?.lastChild?.remove();
        }

    }

    createTemplateChildTabs = (id: string) => {
        if (id && id != "0") {
            this.getTemplateChild(parseInt(id));

            // add template name to design tab
            this.element.querySelector("#myTab").querySelector("#design-tab").innerHTML = Resources["WidgetClient"].designHtml + " - " + this.getTemplateName(id) + "(" + id + ")";

        } else {
            this.element.querySelector("#myTab").querySelector("#design-tab").innerHTML = Resources["WidgetClient"].designHtml;
        }

        // remove all child tab if exist
        this.element.querySelector("#myTab")?.querySelectorAll(".nav-design-child")?.forEach(e => e.remove());
        this.element.querySelector("#myTabContent")?.querySelectorAll(".tab-design-child")?.forEach(e => e.remove());


        if (this.templateChildItems && this.templateChildItems.length > 0) {

            // create child tab
            let fragmentTabElement = <Fragment></Fragment>;
            let fragmentDesignElement = <Fragment></Fragment>;

            // add nav
            this.templateChildItems.forEach(e => {

                this.fillTemplateOptions(parseInt(e.id));

                let area = "design-child";
                let tabId = area + "-tab-" + e.id;
                let tabHref = "#" + area + "-" + e.id;
                let tabContentId = area + "-" + e.id;

                let navElement = <li class="nav-item nav-design-child" role="presentation">
                    <a class="nav-link" id={tabId} data-toggle="tab" href={tabHref} role="tab" aria-controls={area} aria-selected="false">{Resources["WidgetClient"].designHtml} - {e.name} ({e.id}) </a>
                </li>
                fragmentTabElement.appendChild(navElement);

                let tabContentElement = <div class="tab-pane fade h-100 tab-design-child" id={tabContentId} role="tabpanel" aria-labelledby={tabId}>
                    {this.renderMarkupEditor(parseInt(e.id), MeasureTreeTypeEnum.child)}
                </div>
                fragmentDesignElement.appendChild(tabContentElement);

            })
            this.element.querySelector("#myTab").querySelector(".nav-design-parent")?.after(fragmentTabElement);
            this.element.querySelector("#myTabContent").querySelector(".tab-design-parent")?.after(fragmentDesignElement);

        }
    }

    renderAnsichtDropdown(): HTMLElement {
        let div: HTMLElement = <div></div>;
        $.get(app.resolveUrl("~/api/tableView/getViews"), (items: ListItem[]) => {
            this.ansichtDropdown = new DropDownComponent({
                id: "popupMeasureTreeListviewList",
                name: Resources['WidgetClient'].listView,
                displayProperty: "text",
                valueProperty: "value",
                addEmptyItem: true,
                items: items,
                selectedValue: this.props.widget.props.viewId
            });
            div.parentElement.insertBefore(this.ansichtDropdown.render(), div);
            div.parentElement.removeChild(div);
        })
        return div;
    }

    fillTemplateOptions(templateId: number) {
        if (!this.templateOptions.find(f => f.templateId == templateId)) {
            this.templateOptions.push({ templateId: templateId, templateName: this.getTemplateName(templateId.toString()), hasButtonNew: false });
        }
    }

    renderOptionsListview(): HTMLElement {
        this.element.querySelector(".list-view")?.remove();

        let internalProps = {
            displayProperty: "templateName"
        }
        let listProps: ListViewProps = {
            name: Resources.Common.options,
            model: this.templateOptions.sort((a, b) => a.templateId > b.templateId ? 1: -1),
            displayProperty: "templateName",
            allowFilter: false,
            allowSelect: false,
            listItemInternalComponentType: OptionsMeasureTreeListItem,
            listItemInternalComponentProps: internalProps
        };
        this.optionsListview = new ListView(listProps);
        return this.optionsListview .render();
    }

    // get available templates
    getTemplates = () => {
        $.ajax({
            url: app.resolveUrl("~/api/measure/getTemplates"),
            type: "GET",
            async: false,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (result: ListItem[]) => {
                this.templateItems = result;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    // get template children of selected template
    getTemplateChild = (templateId: number) => {
        $.ajax({
            url: app.resolveUrl("~/api/measure/checkTemplateChilds/" + templateId),
            type: "GET",
            async: false,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (result: ListItem[]) => {
                this.templateChildItems = result;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    renderMarkupEditor = (templateId: number, type: MeasureTreeTypeEnum ): HTMLElement => {
        if (this.markup.length == 0 || !this.markup.find(f => f.templateId == templateId)) {
            this.markup.push({ templateId: templateId, markup: "" });
        }
        let model = this.markup.find(f => f.templateId == templateId);

        let editor = <div className="markup-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={model} field="markup" isCss={false} />
            </div>
            <div className="info mt-1">
                {"Daten aus der Maßnahme mit Platzhaltern im Format [UniqueId] anzeigen."}
            </div>
        </div>;
        return editor;
    }

    renderStylesEditor(): HTMLElement {
        return <div className="styles-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="styles" isCss={true} />
            </div>
        </div>;
    }

    renderJsonEditor(): HTMLElement {
        return <div className="styles-editor h-100 d-flex flex-column">
            <div className="position-relative flex-grow-1">
                <AceEditorComponent model={this} field="json" isCss={false} isJson={true} />
            </div>
            <div className="info mt-1">
                {"Lokalisierte Texte als Json-Objekt. Format: \"key\": { \"de\": \"Text\", \"en\": \"Text\", ... }. Verwenden im Markup mit [localize:key]."}
            </div>
        </div>;
    }


    render(): HTMLElement {
        this.getTemplates();
        if (!app.isNullOrUndefined(this.props.widget.props.templateId) && this.props.widget.props.templateId != "") {
            this.getTemplateChild(parseInt(this.props.widget.props.templateId));
        }

        this.getElement();
        this.createTemplateChildTabs(this.props.widget.props.templateId);

        if (!app.isNullOrUndefined(this.props.widget.props.templateId) && this.props.widget.props.templateId != "") {
            this.fillTemplateOptions(parseInt(this.props.widget.props.templateId));
            this.element.querySelector("#settings")?.appendChild(this.renderOptionsListview());
        }
        return this.element;
    }

}
